import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ContentType } from 'src/app/API.service';
import { ContentGridElement } from 'src/app/components/content-grid/content-grid-element';
import { ContentGridSelectMode } from 'src/app/components/content-grid/content-grid-select-mode';
import { ContentSelectDialogComponent } from '../../content-select-dialog/content-select-dialog.component';

@Component({
  selector: 'app-module-form-slide',
  templateUrl: './module-form-slide.component.html',
  styleUrls: ['./module-form-slide.component.scss']
})
export class ModuleFormSlideComponent implements OnInit {

  @Input() formGroup: FormGroup;

  ContentType = ContentType;
  
  constructor(
    private dialog: MatDialog
  ) { }

  element: ContentGridElement = null;

  ngOnInit(): void {
    this.setElement(this.formGroup.value.content)
  }

  setElement(element) {
    this.element = element;
  }

  selectMedia(){

    var data = {
      data: {
        selectMode: ContentGridSelectMode.SINGLE,
        selectedContentId: null
      }  
    } 

    if (this.element != null){
      data.data.selectedContentId = this.element.contentId 
    }

    this.dialog.open(ContentSelectDialogComponent, data).afterClosed().subscribe((result) => {
      if (result.length != 0) {
        this.setElement(result[0])
      }
    })
    
  }
}
